"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { RainforestPayinSessionProvider } from "@/components/rainforest/rainforest-payin-session-context";
import { PaymentPatient } from "@/types/payment";
import { paymentLinkMutationOptions } from "@/api/provider/billing/payment-link-query";
interface BookingFeePayinSessionProviderProps {
  eventId: string;
  patientId: string;
  patient?: PaymentPatient | null;
  enabled: boolean;
  children: ReactNode;
}

/** Shared payin-session wiring for self-schedule and event booking-fee checkout. */
export function BookingFeePayinSessionProvider(t0) {
  const $ = _c(9);
  const {
    eventId,
    patientId,
    patient,
    enabled,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = paymentLinkMutationOptions.createPayinConfigBookingFee();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== eventId || $[2] !== patientId) {
    t2 = t3 => {
      const {
        isSurcharged
      } = t3;
      return {
        eventId,
        patientId,
        isSurcharged
      };
    };
    $[1] = eventId;
    $[2] = patientId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children || $[5] !== enabled || $[6] !== patient || $[7] !== t2) {
    t3 = <RainforestPayinSessionProvider mutationOptions={t1} buildInput={t2} enabled={enabled} patient={patient}>{children}</RainforestPayinSessionProvider>;
    $[4] = children;
    $[5] = enabled;
    $[6] = patient;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}